$(document).ready(function () {
    // hero section 
    $('.hero-custom-section .hero-slider').slick({
      dots: true,
      arrows:false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000
    });
//our collection 
      $('.our-collection-custom .our-collection-main').slick({
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      arrows: true,
      prevArrow: '<div class="slick-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.545851 7.83897C0.256048 7.58308 0.256049 7.13111 0.545851 6.87521L7.12819 1.06296C7.54323 0.69648 8.19655 0.991158 8.19655 1.54485V13.1693C8.19655 13.723 7.54323 14.0177 7.12819 13.6512L0.545851 7.83897Z" fill="#282829"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.38298 7.83897C8.67278 7.58308 8.67278 7.13111 8.38298 6.87521L1.80064 1.06296C1.3856 0.69648 0.732283 0.991158 0.732283 1.54485V13.1693C0.732283 13.723 1.3856 14.0177 1.80064 13.6512L8.38298 7.83897Z" fill="#282829"/></svg></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });


    // featured-product
      $('.product_custom_slider .product-list').slick({
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.545851 7.83897C0.256048 7.58308 0.256049 7.13111 0.545851 6.87521L7.12819 1.06296C7.54323 0.69648 8.19655 0.991158 8.19655 1.54485V13.1693C8.19655 13.723 7.54323 14.0177 7.12819 13.6512L0.545851 7.83897Z" fill="#282829"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.38298 7.83897C8.67278 7.58308 8.67278 7.13111 8.38298 6.87521L1.80064 1.06296C1.3856 0.69648 0.732283 0.991158 0.732283 1.54485V13.1693C0.732283 13.723 1.3856 14.0177 1.80064 13.6512L8.38298 7.83897Z" fill="#282829"/></svg></div>',
     responsive: [
       {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });


      // as seen in
      $('.as-seen-in .as-seen-in__logos').slick({
      dots: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.545851 7.83897C0.256048 7.58308 0.256049 7.13111 0.545851 6.87521L7.12819 1.06296C7.54323 0.69648 8.19655 0.991158 8.19655 1.54485V13.1693C8.19655 13.723 7.54323 14.0177 7.12819 13.6512L0.545851 7.83897Z" fill="#282829"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.38298 7.83897C8.67278 7.58308 8.67278 7.13111 8.38298 6.87521L1.80064 1.06296C1.3856 0.69648 0.732283 0.991158 0.732283 1.54485V13.1693C0.732283 13.723 1.3856 14.0177 1.80064 13.6512L8.38298 7.83897Z" fill="#282829"/></svg></div>',
     responsive: [
       {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });



  
// footer js
  
  $('.footer-menu-box h2').click(function(){
    if ($(window).width() <= 767) {
      $('.footer-menu-box ul').hide();
      $('.footer-menu-box h2').unbind().click(function(){
        $('.footer-menu-box h2').not($(this)).removeClass('active');
        $('.footer-menu-box ul').not($(this).siblings('.footer-menu-box ul')).slideUp();
        $(this).siblings('.footer-menu-box ul').slideToggle();
        $(this).toggleClass('active');
      });
    }
  });



});

var newsletter_button = '.needsclick';
checknewsletterexist();
function checknewsletterexist(count = 0){
  count++;
  if($('button.kl-teaser-UK9dVe.needsclick').length){
    $('.needsclick.kl-private-reset-css-Xuajs1').addClass('newsletter-close');
  }else if(count < 3000){
    setTimeout(function(){
      checknewsletterexist(count);
    },300);
  }
}